// extracted by mini-css-extract-plugin
export default {"head":"tags-list_head__6BDnH","search":"tags-list_search__H0yLu"};